import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";

const FinancialYear = Cookies.get("FinancialYear");
const Firm = Cookies.get("Firm");

const BaseURL = process.env.REACT_APP_API_URL;
const token = Cookies.get("authToken");

const DataBase = Cookies.get("Database");
const ProjectIDs = 1;

export const PLMonth = createAsyncThunk(
  "TrialBalance/PLMonth",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/PLMonth`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PLNormal = createAsyncThunk(
  "TrialBalance/PLNormal",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/PLNormal`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PLTFormat = createAsyncThunk(
  "TrialBalance/PLTFormat",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/PLTFormat`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
          Fromdate: data.Fromdate ? data.Fromdate : "",
          ToDate: data.ToDate ? data.ToDate : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const FirmDtlProLoss = createAsyncThunk(
  "TrialBalance/FirmDtlProLoss",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/FirmDtlProLoss`,
        {
          FirmIDs: Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const PLQuater = createAsyncThunk(
  "TrialBalance/PLQuater",
  async (data) => {
    try {
      const response = await axios.post(
        `${BaseURL}/TrialBalance/PLQuater`,
        {
          FirmIDs: data.Firm,
          DataBase: DataBase,
          ProjectIDs: ProjectIDs,
          AcYearIDs: data.Year,
          AcGroupIDs: data.selectedIds ? data.selectedIds : "",
          AcIDs: data.AcIDs ? data.AcIDs : "",
        },
        {
          headers: {
            token: token,
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
        },
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response ? error.response.data : "Network Error");
    }
  },
);

export const ProFitAndLossSlice = createSlice({
  name: "FAS",
  initialState: {
    PLMonthdata: null,
    PLNormaldata: null,
    PLTFormatdata: null,
    DtlProLossdata: null,
    PLQuaterdata: null,
    status: "idle",
    error: null,
  },
  reducers: {
    PLMonthWiseFan: (state) => {
      state.PLMonthdata = "no";
    },
    PLNormalFan: (state) => {
      state.PLNormaldata = "no";
    },
    PLTNormalFan: (state) => {
      state.PLTFormatdata = "no";
    },
    PLQuaterFan: (state) => {
      state.PLQuaterdata = "no";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PLMonth.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PLMonth.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PLMonthdata = action.payload;
      })
      .addCase(PLMonth.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PLNormal.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PLNormal.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PLNormaldata = action.payload;
      })
      .addCase(PLNormal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PLTFormat.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PLTFormat.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PLTFormatdata = action.payload;
      })
      .addCase(PLTFormat.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(FirmDtlProLoss.pending, (state) => {
        state.status = "loading";
      })
      .addCase(FirmDtlProLoss.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.DtlProLossdata = action.payload;
      })
      .addCase(FirmDtlProLoss.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(PLQuater.pending, (state) => {
        state.status = "loading";
      })
      .addCase(PLQuater.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.PLQuaterdata = action.payload;
      })
      .addCase(PLQuater.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { PLTNormalFan, PLNormalFan, PLMonthWiseFan, PLQuaterFan } =
  ProFitAndLossSlice.actions;

export default ProFitAndLossSlice.reducer;
